// extracted by mini-css-extract-plugin
export default {"howToMakeOrder":"HowToMakeOrder_howToMakeOrder__XUu2E","image":"HowToMakeOrder_image__tw8Ph"};